import React from 'react';

import { initRealUserMonitoring } from 'shared/utils/awsRealUserMonitoring';
import { initErrorTracking } from 'shared/utils/errorTracking/errorTracking';
import { initOtel } from 'shared/utils/initOtel';
import implicitRender from 'shared/utils/implicitRender';

import Eligibility from './';

initErrorTracking();
initRealUserMonitoring();
initOtel();

export default implicitRender(<Eligibility />);
